var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "update_unit",
    attrs: {
      "width": "500",
      "mask-closable": false,
      "title": $t("gpkj3j4", "联系电话")
    },
    on: {
      "on-cancel": _vm.clean
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('div', [_c('Button', {
          on: {
            "click": _vm.clean
          }
        }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
          attrs: {
            "type": "primary",
            "loading": _vm.modal.loading
          },
          on: {
            "click": _vm.onCommit
          }
        }, [_vm._v(` ${$t("l9122", "确认")} `)])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formObj,
      "label-position": "top",
      "rules": _vm.ruleCustom
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("gpkj3j4", "联系电话"),
      "prop": "switchboardNumber"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formObj.switchboardNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "switchboardNumber", $$v);
      },
      expression: "formObj.switchboardNumber"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };